/**
 * 表情组件
 */

import {h, Component} from 'preact';
import FaceMap from 'lib/emoji-map';
import './face.scss';

export default class Face extends Component{
  constructor(props){
    super(props);
  }

  render(props, state){
    let vFaceItem = [];

    for(let key in FaceMap){
      vFaceItem.push(
          <li 
            class='face__item' 
            title={key.slice(1,-1)} 
            onClick={()=>{props.onChoose && props.onChoose(key)}}
          >
            <img src={FaceMap[key]} alt="face"/>
          </li>
      )
    }
    return(
      <div 
        class={[props.class, 'face__wrap'].join(' ')} 
        title=''
        style={{
          display: !!props.show ? 'block' : 'none'
        }}
      >
        <ul class='face__wrap--panel'>
          {vFaceItem}
        </ul>

        <span class='face__wrap--arrow'>
          arrow
        </span>
      </div>
    )
  }
}


/** WEBPACK FOOTER **
 ** ./components/face/face.jsx
 **/